import React from 'react';
import { Link } from 'react-router-dom';
import './DailyBriefing.css';

function DailyBriefing() {
  return (
    <div className="daily-briefing-container">
      <h1 className="daily-briefing-title">Daily Briefing</h1>
      <div className="daily-briefing-video">
        <video src="" alt="Daily Briefing Video" autoPlay loop muted playsInline controls={false} disablePictureInPicture />
      </div>
      <div className="daily-briefing-description">
        <p>The briefing of the future! Get your news, weather updates and calendar briefing all in one convenient place on Spectacles</p>

        <p> Sit back and relax as a calming AI voice reads out your summary for the day with fun graphics.</p>

        <p> Now you can link your Google Calendar for a personalized briefing experience. Which reads out your events for the day ahead.</p>
      </div>

      <h2 className="privacy-heading">
        <Link to="/dbPrivacy" className="privacy-link">Privacy Policy</Link>
      </h2>
    </div>
  );
}

export default DailyBriefing;